import styled from "styled-components";
import {GamePlayPcHeaderBarFreePlayLabelDefaultBox} from "./game-play-pc-header-bar-free-play-label.default.box";

export const GamePlayPcHeaderBarFreePlayLabelWsopBox = styled(GamePlayPcHeaderBarFreePlayLabelDefaultBox)`
  background-color: ${props => props.theme.colors.brandPrimary};
`